import { writable } from 'svelte/store'
import axios from 'axios';

// let backendURL = "http://localhost:5000";
// let backendURL = "http://192.168.137.1:5000";
let backendURL = "https://supremeupholstery.onrender.com";

const config = writable({
  backendURL,
  currentUser: null,
  suppliers: null,
  customers: null,
  items: null,
  fstyles: null,
  departments: ["Sales Rep", "Management"],
  // itemC: ["timber - foam - board - pine", "fabric", "consumables"],
  itemC: ["timber", "foam", "board", "pine", "fabric", "consumables"],
  fStyleC: ["Chairs", "Sofas", "Headboards", "Accessories", "Cabinets", "Ottomans", "Tables", "Servers", "Cushions", "Beds"],
  f: {
    equals: (a, b) => a.toLowerCase().trim().replaceAll(" ", "").replaceAll(/\W/g, '') == b.toLowerCase().trim().replaceAll(" ", "").replaceAll(/\W/g, ''),
    _has_: (a, b) => a.toLowerCase().trim().replaceAll(" ", "").replaceAll(/\W/g, '').includes(b.toLowerCase().trim().replaceAll(" ", "").replaceAll(/\W/g, '')),
    titleCase: (str) => {
      let splitStr = str.toLowerCase().split(' ');
      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(' ');
    },
    time: () => Math.floor(new Date().getTime() % 20) * 40,
    log: async (body, type, qty) => {
      let res = await axios
        .post(`${backendURL}/logs`, { body, type, qty }, {
          headers: { authorization: localStorage.getItem("jwt") },
        });
      console.log(res.data);
    }
  }
});

export default config;